export const StyledSpinner = {
  width: "60px",
};
